module.exports = __webpack_public_path__ + "img/عکس محصول یاخدمات.08d98944.jpg";